/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum RecordingOfConsentAliases {
  BUTTON_CANCEL_DISCARD_CONSENT = 'button-cancel-discard-consent',
  BUTTON_CLOSE_TRANSCRIPT_TEXTS = 'button-close-transcript-texts',
  BUTTON_DISCARD_CONSENT = 'button-discard-consent',
  BUTTON_DISCARD_RECORDING_OF_CONSENT = 'button-discard-recording-of-consent',
  BUTTON_SAVE_RECORDING_OF_CONSENT = 'button-save-recording-of-consent',
  BUTTON_SHOW_TRANSCRIPT_TEXTS = 'button-show-transcript-texts',
  GLOBAL_ACTIONS_DISCARD_CONSENT = 'global-actions-discard-consent',
  GLOBAL_ACTIONS_TRANSCRIPT_TEXTS = 'global-actions-transcript-texts',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  LAYOUT_CONTENT = 'layout-content',
  LAYOUT_CONTENT_RECORDING = 'layout-content-recording',
  LAYOUT_GLOBAL_BUTTONS = 'layout-global-buttons',
  LAYOUT_RECORDING_OF_CONSENT = 'layout-recording-of-consent',
  MODAL_DISCARD_CONSENT = 'modal-discard-consent',
  MODAL_TRANSCRIPT_TEXTS = 'modal-transcript-texts',
  PANEL_BUTTON_DISCARD = 'panel-button-discard',
  PANEL_BUTTON_SAVE = 'panel-button-save',
  PANEL_CONENT = 'panel-conent',
  PANEL_DISCARD_CONSENT = 'panel-discard-consent',
  PANEL_DISCARD_CONSENT_CONTENT = 'panel-discard-consent-content',
  PANEL_DISCARD_CONSENT_CONTENT_TEXT = 'panel-discard-consent-content-text',
  PANEL_GLOBAL_ACTIONS_RECORDING_OF_CONSENT = 'panel-global-actions-recording-of-consent',
  PANEL_INFORMATION_BAR_HEADER = 'panel-information-bar-header',
  PANEL_RECORDING_OF_CONSENT_CONTENT = 'panel-recording-of-consent-content',
  PANEL_SHOW_TRANSCRIPT_TEXTS = 'panel-show-transcript-texts',
  PANEL_TITLE = 'panel-title',
  PANEL_TRANSCRIPT_RESULTS = 'panel-transcript-results',
  PANEL_TRANSCRIPT_TEXTS = 'panel-transcript-texts',
  TEXT_AREA_TRANSCRIPT_RESULTS = 'text-area-transcript-results',
  TEXT_DISCARD_CONSENT = 'text-discard-consent',
  TEXT_RECORD_STATUS = 'text-record-status',
  TEXT_TITLE_DISCARD_CONSENT = 'text-title-discard-consent',
  TEXT_TOUCH_TO_START = 'text-touch-to-start',
  TIMER = 'timer',
  VA_BUTTON = 'va-button',
}
export { RecordingOfConsentAliases };
